import { Metamodel } from 'app/model/base/model';
import { DelimitedTextDataset } from 'shell-models-lib';
import { FormatReadSettings } from './format-read-settings';
import { IAttribute } from 'app/model/base/annotation';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.delimitedText.formatRead,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(DelimitedTextDataset) }
})
export class DelimitedTextFormatReadSettings extends FormatReadSettings {
    public static readonly COMMENT_CHAR: IAttribute;
    public static readonly IGNORE_LEADING_WHITESPACE: IAttribute;
    public static readonly IGNORE_TRAILING_WHITESPACE: IAttribute;
    public static readonly ADDTIONAL_NULL_VALUES: IAttribute;
    public static readonly SKIP_LINE_COUNT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMMENT_CHAR',
        display: stringResources.ModelName_CommentChar
    })
    public commentChar: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'IGNORE_LEADING_WHITESPACE',
        display: stringResources.ModelName_IgnoreLeadingWhiteSpace
    })
    public ignoreLeadingWhiteSpace: boolean;

    @Metamodel.attribute({
        templatable: true,
        association: 'IGNORE_TRAILING_WHITESPACE',
        display: stringResources.ModelName_IgnoreTrailingWhiteSpace
    })
    public ignoreTrailingWhiteSpace: boolean;

    @Metamodel.attribute({
        templatable: true,
        association: 'ADDTIONAL_NULL_VALUES',
        display: stringResources.ModelName_AddtionalNullValues
    })
    public addtionalNullValues: string[];

    @Metamodel.attribute({
        templatable: true,
        association: 'SKIP_LINE_COUNT',
        display: stringResources.SkipLineCountLabel
    })
    public skipLineCount: number;
}
